import { Validator } from 'vee-validate';
import { BasicSelect } from 'vue-search-select';
import CreateClientTc from './../CreateClientTC';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import ClientService from './../../../services/clientmanagement.service';
import CONSTANT from './../../../../shared/constants/constant';
import VueElementLoading from 'vue-element-loading';
import MasterService from './../../../../masterdata/services/masterdata.service';
import Util from './../../../../shared/util/util'
import Multiselect from 'vue-multiselect'
export default {
	name: 'ClientTClisting',
	components: {
		BasicSelect,
		CustomExpandableTable,
		CreateClientTc,
		VueElementLoading,
		Pagination,
		Multiselect
	},
	props: [],
	data() {
		return {
			CompanyShortList: [],
			templatelist: [],
			selectedcompanyName: {
				"value": '',
				"text": ''
			},
			showlist: true,
			isLoading: false,
			isViewLoading: false,
			companyName: '',
			contractId: '',
			systemId: '',
			contractiditem: {
				value: '',
				text: ''
			},
			tableColumn: ['Client System ID', 'Client Business Account ID','Company Short/Display Name', 'Contract ID','Created By','Created Date','Last Modified By','Last Modified Date','Contract Status','Action'],
			innerTableColumn: [],
			selectedContractId: {
				"value": '',
				"text": ''
			},
			tableItems: [],
			currentPage: 1,
			totalPage: 0,
			totalCount: 0,
			offset: 0,
			pageLimit: CONSTANT.PER_PAGE_DATA,
			selectedTCObj: [],
			contractIdList: [],
			billingCycle: '',
			pod: '',
			date1: '',
			date2: '',
			podCharge: '',
			podChargeEnable: false,
			creditPeriod: '',
			creditLimit: '',
			advancePayment: '',
			creditAlert: '',
			paymentmode: [],
			liabilityAmount: '',
			expanded:false,
			accordianTab:{1:false, 2:false, 3:false}
		}
	},
	computed: {

	},
	mounted() {
		this.getClientTCList();
		this.getCompanyShortName();
		this.getContractIdList();
		this.getTemplateList();
	},
	methods: {
		expandAll(){
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll(){
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid){
			this.expanded = false;
			for (var key in this.accordianTab) {
				if(tabid != key){
					this.accordianTab[key] = false;
				}
			}
		},
		async getCompanyShortName() {
			try {
				this.isLoading = true;
				var CompanyShortList = []
				let result = await ClientService.getActiveInactiveClientList()
				CompanyShortList = this.getUniqueCompanyList(result.data.data);
				for (var i = 0; i < CompanyShortList.length; i++) {
					this.CompanyShortList.push({
						'value': CompanyShortList[i].ClientMasterID,
						'text': CompanyShortList[i].ClientShortName,
						'ClientBusinessAccountId': CompanyShortList[i].ClientBusinessAccountId
					})
				}
				this.isLoading = false;
			} catch (err) {
				console.log(err);
			}
		},
		getUniqueCompanyList(array){
			let mymap = new Map();
			let unique = array.filter(el => {
					const val = mymap.get(el.ClientMasterID);
					if(val) {
							if(el.ClientShortName < val) {
									mymap.delete(el.ClientMasterID);
									mymap.set(el.ClientMasterID, el.ClientShortName, el.ClientBusinessAccountId);
									return true;
							} else {
									return false;
							}
					}
					mymap.set(el.ClientMasterID, el.ClientShortName,el.ClientBusinessAccountId);
					return true;
			});
			return unique;
		},
		async getContractIdList(){
      try {
        let inputPayload = {};
        let result = await ClientService.getClientContractDropdownList(inputPayload);
        let contractlist = result.data.data;
        for (var i = 0; i < contractlist.length; i++) {
          this.contractIdList.push({
            'value': contractlist[i].id,
            'text': contractlist[i].contractidlabel
          })
        }
      } catch(err){
        console.log(err);
      }
    },
		async getTemplateList() {
			this.isLoading = true;
			let inputPayload = {};
			var result = await MasterService.getTemplateListForDropDown(inputPayload);
			for (var i = 0; i < result.data.data.length; i++) {
				this.templatelist.push({
					text: result.data.data[i].termsconditionname,
					value: result.data.data[i].id
				})
			}
			this.isLoading = false;
		},
		async selectContractId(data) {
			this.selectedContractId = data;
			this.contractId = data.value;
		},
		selectCompanyName(data) {
			this.selectedcompanyName = data;
			this.companyName = data.value;
		},
		showAddForm() {
			this.selectedTCObj = [];
			this.showlist = false;
		},
		callParent() {
			this.showlist = true;
			this.currentPage = 1;
			this.offset = 0;
			this.getClientTCList();
		},
		onPageChange(page) {
      this.currentPage = page;
			this.offset = (page - 1) * this.pageLimit;
      this.getClientTCList();
    },
		searchTC() {
			this.currentPage = 1;
			this.offset = 0;
			this.getClientTCList();
		},
		resetTC() {
			this.selectedcompanyName = {};
			this.selectedContractId = {};
			this.currentPage = 1;
				this.offset = 0;
			this.companyName = "";
			this.contractId = "";
			this.systemId = "";
			this.getClientTCList();
		},
		async getClientTCList() {
			this.isLoading = true;
			try {
				let inputPayload = {
					"offset": this.offset,
					"limit": this.pageLimit,
				}
				if (this.companyName) {
					inputPayload.companyname = this.companyName.value;
				}
				if (this.contractId) {
					inputPayload.contractid = this.contractId.value;
				}
				if (this.systemId != '') {
					inputPayload.clientid = this.systemId;
				}

				let result = await ClientService.getClientTCList(inputPayload);

				this.tableArr = result.data.data.rows;
				this.isLoading = false;
				this.totalCount = result.data.data.count;

				if (this.totalCount > 0) {
					this.tableArr = result.data.data.rows;
					this.tableItems = result.data.data.rows.map((el) => {
						return {
							'id': el.id,
							'Client System ID': el.clientcontract.clientid,
							'Client Business Account ID':el.clientcontract.clientbusinessaccountid,
							'Contract ID': el.clientcontract.contractidlabel,
							'Company Short/Display Name': el.clientcontract.clientshortname,
							'Created By':el.createdby,
	                        'Created Date':Util.displayDateTimeFormat(el.createddate),
							'Last Modified By':el.lastmodifiedby,
						  'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
							'Contract Status': CONSTANT.CONTRACT_STATUS[el.clientcontract.contractstatus],
							'Action': el.clientcontract.contractstatus,
						}
					})
				} else {
					this.tableItems = [];
				}
				if (this.totalCount < 10) {
					this.totalPage = 1
				} else {
					this.totalPage = Math.ceil(this.totalCount / 10);
				}
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},
		getCustomTableEvent(event) {
			if (event.actionType == "active") {
				this.$confirm("Are you sure to make Active/Inactive?", "", "question").then(() => {
					this.activeAction(event);
				}).catch((err) => {
					console.log(err)
				});
			} else if (event.actionType == "inactive") {
				this.$confirm("Are you sure to make Active/Inactive?", "", "question").then(() => {
					this.activeAction(event);
				}).catch((err) => {
					console.log(err)
				})
			}
			if (event.actionType == "edit") {
				let selectedTCObj = this.tableArr.filter(function(Items) {
					return Items.id == event.id;
				});
				this.selectedTCObj = selectedTCObj[0];
				this.showlist = false;
			} else if (event.actionType == "view") {
				this.getClientContractDetailsById(event.id);
			}
		},
		async getClientContractDetailsById(tcid) {
			this.isViewLoading = true;
			let input = {
				clienttcid: tcid
			}
			let result = await ClientService.getclientTermsConditionDetails(input);
			var data = result.data.data[0]
			this.billingCycle = data.billingcycle;
			if( data.podhardcopyrequired==1){
				this.pod = "Yes";
			}else{
				this.pod = "No";
			}
			this.podCharge = data.podhardcopycharges;
			if(data.billingcycle == 1){
				this.billingCycle = "Monthly";
				this.date1 = data.billsubmissionlastdate.cycle1;
				this.date2 = '';
			}else if(data.billingcycle == 2){
				this.billingCycle = "Fortnightly";
				this.date1 = data.billsubmissionlastdate.cycle1;
				this.date2 = data.billsubmissionlastdate.cycle2;
			}else if(data.billingcycle == 3){
				this.billingCycle = "Weekly";
			}

			this.creditPeriod = data.creditperioddays;
			this.creditLimit = data.creditlimit;
			this.advancePayment = data.ftladvancepayment;
			this.creditAlert = data.creditlimitalert;
			let tempArr = [];
			if(data.paymentmode.includes("1")){
				tempArr.push("Cheque");
			}
			if(data.paymentmode.includes("2")){
				tempArr.push("Demand Draft");
			}
			if(data.paymentmode.includes("3")){
				tempArr.push("RTGS");
			}
			this.paymentmode = tempArr.join(", ");
			this.liabilityAmount = data.maxliability;
			this.isViewLoading = false;
		},
		onSubmit() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.searchTC();
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/ClientTC/ClientTCListing/ClientTCListing.component.js